module.exports = __webpack_public_path__ + "static/GPlogoWhiteBG-350d21b0113091cd53ea01f3b0d501c5.png";